import type { App } from 'vue'

import LazyRender from '@/components/shared/v2/lazy-render.vue'
import Loader from '@/components/shared/loader.vue'
import SvgIcon from '@/components/shared/v2/svg-icon.vue'
import DynamicStars from '@/components/shared/dynamic-stars.vue'
import BackToTop from '@/components/shared/back-to-top.vue'
import ShareButton from '@/components/shared/share-button.vue'
import LoaderButton from '@/components/shared/v2/loader-button.vue'

import BundleSummaryToggle from '@/components/bundle/bundle-summary-toggle.vue'
import BundleSummary from '@/components/bundle/bundle-summary.vue'

import BundleSizePlan from '@/components/bundle/bundle-size-plan.vue'
import VarietyPacksButtonGroup from '@/components/bundle/variety-packs-button-group.vue'
import ProductFilters from '@/components/products/product-filters.vue'
import ProductTagIcons from '@/components/products/product-tag-icons.vue'
import ProductReviewsStars from '@/components/products/product-reviews-stars.vue'
import ProductNutrition from '@/components/products/product-nutrition.vue'
import ProductPricing from '@/components/products/product-pricing.vue'
import ProductCards from '@/components/products/product-cards.vue'
import BundleQuantityControl from '@/components/products/bundle-quantity-control.vue'
import BlenderWidget from '@/components/shared/blender-widget.vue'
import VarietyPackSplide from '@/components/variety-packs/variety-pack-splide.vue'
import VarietyPackContents from '@/components/variety-packs/variety-pack-contents.vue'

export const themePlugin = {
  install(app: App) {
    // shared
    app.component('lazy-render', LazyRender)
    app.component('svg-icon', SvgIcon)
    app.component('inline-loader', Loader)
    app.component('dynamic-stars', DynamicStars)
    app.component('back-to-top', BackToTop)
    app.component('share-button', ShareButton)
    app.component('loader-button', LoaderButton)

    // bundler
    app.component('bundle-summary-toggle', BundleSummaryToggle)
    app.component('bundle-summary', BundleSummary)
    app.component('bundle-size-plan', BundleSizePlan)
    app.component('variety-packs-button-group', VarietyPacksButtonGroup)

    // products
    app.component('product-filters', ProductFilters)
    app.component('product-tag-icons', ProductTagIcons)
    app.component('product-reviews-stars', ProductReviewsStars)
    app.component('product-nutrition', ProductNutrition)
    app.component('product-pricing', ProductPricing)
    app.component('product-cards', ProductCards)
    app.component('bundle-quantity-control', BundleQuantityControl)
    app.component('blender-widget', BlenderWidget)
    app.component('variety-pack-splide', VarietyPackSplide)
    app.component('variety-pack-contents', VarietyPackContents)
  }
}

export default themePlugin
